import { ManageUsersFabModule } from './manage-users-fab/manage-users-fab.module';

import * as angular from 'angular';
import { ManageUsersFiltersModule } from './manage-users-filters/manage-users-filters.module';
import { ManageUsersHeaderModule } from './manage-users-header/manage-users-header.module';
import { ManageUsersCreateNewUserModalModule } from './manage-users-modals/create-or-edit-user/manage-users-create-or-edit-user-modal.module';
import { ManageUsersEditPermissionsModalModule } from './manage-users-modals/edit-permissions/manage-users-edit-permissions-modal.module';
import { ManageUsersTableModule } from './manage-users-table/manage-users-table.module';
import { ManageUsersComponent } from './manage-users.component';

export const ManageUsersModule = angular
  .module('manageUsers', [
    ManageUsersFiltersModule,
    ManageUsersTableModule,
    ManageUsersHeaderModule,
    ManageUsersCreateNewUserModalModule,
    ManageUsersEditPermissionsModalModule,
    ManageUsersFabModule,
  ])
  .component('manageUsers', ManageUsersComponent).name;
